"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    marginLeft: 15,
    marginRight: 15,
    width: '100%',
    height: 50,
    color: 'black',
};
